import React from 'react'
import { useAdvisorsData } from '../../../hooks/useAdvisorsData'
import { useModuleConfig } from '../../hooks/useModuleConfig'
import { MODULE_KEYS, DISCLOSURE_DEFAULTS } from '../../moduleRegistry'
import { AdvisorData, RoboAdvisorData } from '../../../utils/types'
import { DisclosureHeading } from './DisclosureHeading'
import { DisclosureSubheading } from './DisclosureSubheading'
import { DisclosureBlock } from './DisclosureBlock'
import '../../styles/DisclosureModule/DisclosureModule.scss'

type AdvisorEntry = AdvisorData | RoboAdvisorData

export const DisclosureModule = () => {
  const { heading, subheading } = useModuleConfig(MODULE_KEYS.disclosure, DISCLOSURE_DEFAULTS)
  const advisorsData = useAdvisorsData() as AdvisorEntry[] | undefined

  const visibleAdvisors = advisorsData?.filter(
    (data) => 'cp_display_disclosure' in data.advisor && data.advisor.cp_display_disclosure === 'true'
  ) ?? []

  if (visibleAdvisors.length === 0) return null

  return (
    <section className="disclosure-module" aria-labelledby="disclosure-heading">
      <DisclosureHeading heading={heading} fallback={DISCLOSURE_DEFAULTS.heading} />
      <DisclosureSubheading subheading={subheading} fallback={DISCLOSURE_DEFAULTS.subheading} />
      <p className="disclosure-module__list-label"><strong>Disclosures:</strong></p>
      <ol className="disclosure-module__list">
        {visibleAdvisors.map((data, i) => (
          <DisclosureBlock
            key={`disclosure-${data.advisor.id ?? i}`}
            advisor={data.advisor}
          />
        ))}
      </ol>
    </section>
  )
}
